module.exports = __webpack_public_path__ + "img/1541641515.1fc8aa20.jpg";